import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import './Login.css';
import { Backdrop, CircularProgress } from '@mui/material';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import errorMessages from '../../utils/errorMessagesUtil';
import { useForm } from 'react-hook-form';
import { useAppProviderStore } from 'store/appProviderCopyStore';
import { useNotification } from 'hooks/useNotification';

function LoginPage() {
  const navigate = useNavigate();
  const { search } = useLocation();

  const { setCognitoUserChangePassword } = useAppProviderStore();
  const [isLoading, setIsLoading] = useState(false);
  const { setNotify } = useNotification();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [showPassword, setShowPassword] = React.useState(false);

  const getQueryParam = param => {
    const queryParams = new URLSearchParams(search);
    return queryParams.get(param);
  };

  const pathParam = getQueryParam('path');

  const handleClickShowPassword = () => setShowPassword(show => !show);
  const {
    register,
    formState: { errors },
    trigger,
  } = useForm();

  const handleMouseDownPassword = event => {
    event.preventDefault();
  };

  const handleLogin = async () => {
    setIsLoading(true);
    try {
      const user = await Auth.signIn(email, password);
      setCognitoUserChangePassword(user);
      if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
        navigate('/confirmLogin');
      } else {
        if (pathParam) {
          navigate(pathParam);
        } else {
          navigate('/');
        }
      }
      setIsLoading(false);
    } catch (err) {
      console.log(err);
      setNotify({
        isOpen: true,
        message: errorMessages[err.message],
        type: 'error',
        title: 'Ops! Algo deu errado...',
      });
      setIsLoading(false);
    }
  };
  const enterPresskey = event => {
    if (event.keyCode === 13) {
      handleLogin();
    }
  };

  return (
    <div
      className="container_login"
      style={{ backgroundImage: 'url(/img/bg-login.png)' }}>
      <div className="line_header_login"></div>
      <div className="login">
        <div className="login_logo">
          <img
            src="/img/Logo_SescDigital_Pos.svg"
            alt="Logo"
            className="login_image"
          />
        </div>
        <div className="login_form">
          <div className="login_form_items">
            <p className="login_form_titulo">Entrar</p>
            <div className="real_form">
              <Backdrop open={isLoading} style={{ zIndex: 9999 }}>
                <CircularProgress color="inherit" />
              </Backdrop>
              <Box
                sx={{ lg: 1, width: '100%' }}
                onKeyDown={e => enterPresskey(e)}>
                <FormControl
                  sx={{ lg: 1, width: '90%', marginBottom: '5%' }}
                  variant="standard">
                  <InputLabel htmlFor="standard-adornment-email">
                    E-mail
                  </InputLabel>
                  <Input
                    id="standard-adornment-email"
                    type="email"
                    name="email"
                    {...register('email', {
                      onChange: e => {
                        setEmail(e.target.value);
                        trigger(e.target.name);
                      },
                      required: true,
                      pattern:
                        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                    })}
                    aria-invalid={errors.email ? 'true' : 'false'}
                    onBlur={evt => {
                      trigger(evt.target.name);
                    }}
                  />
                  {errors.email?.type === 'required' && (
                    <p className="authFormError" role="alert">
                      Campo obrigatório.
                    </p>
                  )}
                  {errors.email?.type === 'pattern' && (
                    <p className="authFormError" role="alert">
                      Formato de usuário/email invalido.
                    </p>
                  )}
                </FormControl>
                <FormControl sx={{ lg: 1, width: '90%' }} variant="standard">
                  <InputLabel htmlFor="standard-adornment-password">
                    Senha
                  </InputLabel>
                  <Input
                    id="standard-adornment-password"
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    {...register('password', {
                      onChange: e => {
                        setPassword(e.target.value);
                        trigger(e.target.name);
                      },
                      required: true,
                    })}
                    aria-invalid={errors.password ? 'true' : 'false'}
                    onBlur={evt => {
                      trigger(evt.target.name);
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}>
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                  {errors.password?.type === 'required' && (
                    <p className="authFormError" role="alert">
                      Campo obrigatório.
                    </p>
                  )}
                </FormControl>
              </Box>
            </div>
            <div className="login_button">
              <button className="login_button_style" onClick={handleLogin}>
                Confirmar
              </button>
            </div>
            <div className="login_forgot_password">
              <Link
                className="login_forgot_password_text"
                as="a"
                to="/forgotPasswordCode">
                Esqueci a senha
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="line_bottom_login"></div>
    </div>
  );
}

export default LoginPage;
